import { render, staticRenderFns } from "./PropertyRow.vue?vue&type=template&id=c74c4596"
import script from "./PropertyRow.vue?vue&type=script&lang=js"
export * from "./PropertyRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports